import { IBaseModel, BaseModel } from '../base.model';
import { UserTypes } from '../../common/enums';

export interface IUserDetails extends IBaseModel {
  type?: string;
  role_id?: number;
  role?: string;
  role_name?: string;
  entity?: string;
  email?: string;
  cellphone?: string;
  landline?: string;
  firstname?: string;
  lastname?: string;
  birthdate?: string | null;
  notification_app?: boolean;
  notification_mail?: boolean;
  notification_sms?: boolean;
  forgot_me?: boolean;
  fk_entity_civility_legal_form?: number;
  fk_entity_user?: number;
  fk_entity_address?: number;
  address?: { id?: number; line1?: string; line2?: string; zip_code?: string; city?: string; iris_code?: string; country?: string; createdAt?: string; updatedAt?: string; };
  picture?: any[];
  manager?: { id?: number; fk_manager_entity?: number; createdAt?: string; updatedAt?: string; };
  modules: string[];
  civility_shorten?: string;
  civility_name?: string;
  my_picture?: string;
  problem_solver?: number[]
  legal_entity?: { siret: string, ape: string, tva: string }
  fk_entity_signature?: number
  signature?: string
  trigram?: string
  template?:string
}
export class UserDetails extends BaseModel {
  /**
   *
   */
  type?: string;
  role_id?: number
  role?: string;
  role_name?: string;
  entity?: string;
  email?: string;
  cellphone?: string;
  landline?: string;
  firstname?: string;
  lastname?: string;
  birthdate?: string | null;
  notification_app?: boolean;
  notification_mail?: boolean;
  notification_sms?: boolean;
  forgot_me?: boolean;
  fk_entity_civility_legal_form?: number;
  fk_entity_user?: number;
  fk_entity_address?: number;
  address?: { id?: number; line1?: string; line2?: string; zip_code?: string; city?: string; iris_code?: string; country?: string; createdAt?: string; updatedAt?: string; };
  picture?: any[];
  manager?: { id?: number; fk_manager_entity?: number; createdAt?: string; updatedAt?: string; };
  modules: string[];
  blocks?: any[]
  apartments?: any[]
  problem_solver?: number[]
  legal_entity?: { siret: string, ape: string, tva: string }
  fk_entity_signature?: number
  trigram?: string
  template?:string

  constructor(opt?: IUserDetails) {
    super(opt);
    this.modules = [];
    this.blocks = [];
    this.type = UserTypes.Tenant;
  }
}



// WEBPACK FOOTER //
// ./src/models/user/user-details.model.ts